import { getRequest, patchRequest, deleteRequest, postRequest } from 'services/requests';

export default {
    findAccount: (id) => getRequest(`/accounts/${id}`),
    updateAccount: (id, body) => patchRequest(`/accounts/${id}`, body),
    deleteAccount: (id) => deleteRequest(`/accounts/${id}`),
    deleteMessage: (id) => deleteRequest(`/chats/${id}`),
    deleteFile: (id) => deleteRequest(`/chats/${id}/files`),
    findAccountFiles: (id) => getRequest(`/accounts/${id}/files`),
    findAccountSharedUrls: (id) => getRequest(`/accounts/${id}/shared-urls`),
    findAccountTasks: (id) => getRequest(`/accounts/${id}/tasks`),
    getChatFiles: (id, filter = null, orderBy = null, skip = null, top = 30) =>
        getRequest(`/chats/${id}/files?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`),
    getAccountTokens: (id) => getRequest(`/accounts/${id}/tokens`),
    createChannels: (id, body) => postRequest(`/chats/${id}`, body),
    listMessages: (id, filter = null, orderBy = null, skip = null, top = 30) =>
        getRequest(`/chats/${id}?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`),
};
